import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PlantDepActivityLayer from "../components/PlantDepActivityLayer";

const PlantDepActivityTablePage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Departmental Activity" tooltipContent="Add New Complaint" linkTo="/complains/add"  requiredPermission={{ module: 'complaints', action: 'create' }}/>
    
        {/* TableDataLayer */}
        <PlantDepActivityLayer />

      </MasterLayout>

    </>
  );
};

export default PlantDepActivityTablePage; 
